import { render, staticRenderFns } from "./BookDetailTable.vue?vue&type=template&id=2b7745bc&"
import script from "./BookDetailTable.vue?vue&type=script&lang=js&"
export * from "./BookDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports